<h1 matDialogTitle>{{ 'Delete Certificate' | translate }}</h1>
<form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
  <p>
    {{ 'Are you sure you want to delete "{cert}"?' | translate: { cert: data.cert.name } }}
  </p>
  <ix-checkbox
    formControlName="force"
    [label]="'Force' | translate"
  ></ix-checkbox>

  <ix-form-actions>
    <button mat-button type="button" ixTest="cancel" [mat-dialog-close]="false">
      {{ 'Cancel' | translate }}
    </button>

    <button mat-button type="submit" color="red" ixTest="delete">
      {{ 'Delete' | translate }}
    </button>
  </ix-form-actions>
</form>
